import Ajax from '../../../../util/ajax';
export function zigbeeStepWithOnOff(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/step-with-on-off';
        const value = {
            'mode': payload.mode,
            'size': payload.size,
            'transition time': payload.transitionTime
        };
        ajax.post(url, value);
    };
}
